import React from "react";
var __jsx = React.createElement;
import OilProductOptions from "../OilProductCard/OilProductOptions";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
var OilProductSelection = function OilProductSelection(_ref) {
  var section = _ref.section,
    onShareOpen = _ref.onShareOpen;
  var title = section.title,
    content = section.content;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "order-1 hidden md:flex items-center justify-between gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex items-center gap-3"
  }, content.logo && /*#__PURE__*/React.createElement("div", {
    className: "box-border flex items-center justify-center bg-white  h-14 w-14 min-w-[52px] max-w-[60px] border-[#E6E9EF] rounded-lg flex-shrink-0 overflow-hidden"
  }, /*#__PURE__*/React.createElement("img", {
    src: content.logo,
    alt: title,
    className: "w-full h-full object-contain",
    loading: "eager"
  })), !isMobile && /*#__PURE__*/React.createElement("h1", {
    className: "text-2xl font-semibold leading-snug m-0"
  }, title)), onShareOpen && /*#__PURE__*/React.createElement("button", {
    onClick: onShareOpen,
    className: "w-9 h-9 bg-white border-none  flex items-center justify-center flex-shrink-0 hover:bg-[#eef0fb] hover:rounded-lg transition-colors",
    "aria-label": "\u0634\u0627\u0631\u0643 \u0627\u0644\u0645\u0646\u062A\u062C"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--ios-share-rounded",
    className: "text-primary-new",
    width: 6,
    height: 6
  }))), content.description && /*#__PURE__*/React.createElement("p", {
    className: "py-5 mt-5  border-solid border-t border-[#E0E0E0] md:py-0 md:mt-0 md:border-none order-3 md:order-2 md:text-base text-sm  leading-relaxed m-0"
  }, content.description), /*#__PURE__*/React.createElement("div", {
    className: "order-2 md:order-3"
  }, /*#__PURE__*/React.createElement(OilProductOptions, {
    section: section
  })));
};
export default OilProductSelection;